// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/delete_vision_board_generations.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/delete_vision_board_generations.proto.
 */
export const file_vision_generations_v1_delete_vision_board_generations: GenFile = /*@__PURE__*/
  fileDesc("Cjt2aXNpb24vZ2VuZXJhdGlvbnMvdjEvZGVsZXRlX3Zpc2lvbl9ib2FyZF9nZW5lcmF0aW9ucy5wcm90bxIccHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MSK1AQojRGVsZXRlVmlzaW9uQm9hcmRHZW5lcmF0aW9uc1JlcXVlc3QSWAoGcGFyYW1zGAEgASgLMkgucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5EZWxldGVWaXNpb25Cb2FyZEdlbmVyYXRpb25zUmVxdWVzdC5QYXJhbXMaNAoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSFgoOZ2VuZXJhdGlvbl9pZHMYAiADKAkiiwEKJERlbGV0ZVZpc2lvbkJvYXJkR2VuZXJhdGlvbnNSZXNwb25zZRJZCgZyZXN1bHQYASABKAsySS5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkRlbGV0ZVZpc2lvbkJvYXJkR2VuZXJhdGlvbnNSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest
 */
export type DeleteVisionBoardGenerationsRequest = Message<"protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest.Params params = 1;
   */
  params?: DeleteVisionBoardGenerationsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest.
 * Use `create(DeleteVisionBoardGenerationsRequestSchema)` to create a new message.
 */
export const DeleteVisionBoardGenerationsRequestSchema: GenMessage<DeleteVisionBoardGenerationsRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_vision_board_generations, 0);

/**
 * @generated from message protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest.Params
 */
export type DeleteVisionBoardGenerationsRequest_Params = Message<"protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string generation_ids = 2;
   */
  generationIds: string[];
};

/**
 * Describes the message protos.vision.generations.v1.DeleteVisionBoardGenerationsRequest.Params.
 * Use `create(DeleteVisionBoardGenerationsRequest_ParamsSchema)` to create a new message.
 */
export const DeleteVisionBoardGenerationsRequest_ParamsSchema: GenMessage<DeleteVisionBoardGenerationsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_vision_board_generations, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse
 */
export type DeleteVisionBoardGenerationsResponse = Message<"protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse.Result result = 1;
   */
  result?: DeleteVisionBoardGenerationsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse.
 * Use `create(DeleteVisionBoardGenerationsResponseSchema)` to create a new message.
 */
export const DeleteVisionBoardGenerationsResponseSchema: GenMessage<DeleteVisionBoardGenerationsResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_vision_board_generations, 1);

/**
 * @generated from message protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse.Result
 */
export type DeleteVisionBoardGenerationsResponse_Result = Message<"protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse.Result"> & {
};

/**
 * Describes the message protos.vision.generations.v1.DeleteVisionBoardGenerationsResponse.Result.
 * Use `create(DeleteVisionBoardGenerationsResponse_ResultSchema)` to create a new message.
 */
export const DeleteVisionBoardGenerationsResponse_ResultSchema: GenMessage<DeleteVisionBoardGenerationsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_delete_vision_board_generations, 1, 0);

